// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-component-container {
  padding: 30px;
}
@media only screen and (max-width: 768px) {
  .card-component-container {
    padding: 10px;
  }
}

.topic-overview-card.highlight {
  color: var(--base_color2);
  background-color: var(--color_primary_500);
}
.topic-overview-card.highlight h3,
.topic-overview-card.highlight h5 {
  color: var(--base_color2);
}
.topic-overview-card.highlight p {
  color: #d2dcff;
}
.topic-overview-card.highlight:hover {
  background-color: var(--color_primary_500);
}
.topic-overview-card:hover {
  background-color: var(--gray_insights3_hover);
}
.topic-overview-card {
  color: var(--primary_dark2);
  width: 100%;
  background-color: var(--gray_insights3);
}
.topic-overview-card h3,
.topic-overview-card h5 {
  color: var(--primary_dark2);
}
.topic-overview-card h5 {
  font-size: 16px;
}
.topic-overview-card .semibold {
  font-weight: 600;
}
.topic-overview-card .bold {
  font-weight: 700;
}
.topic-overview-card p {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
}
.topic-overview-card.analytics {
  border-radius: 16px;
  width: 100%;
  max-width: 429px;
  height: 306px;
}
.topic-overview-card.related-topic {
  border-radius: 8px;
  width: 100%;
  max-width: 317px;
  height: 216px;
}`, "",{"version":3,"sources":["webpack://./src/components/card/card.styles.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAGE;EAHF;IAII,aAAA;EAAF;AACF;;AAIE;EACE,yBAAA;EACA,0CAAA;AADJ;AAGI;;EAEE,yBAAA;AADN;AAII;EACE,cAAA;AAFN;AAKI;EACE,0CAAA;AAHN;AAOE;EACE,6CAAA;AALJ;AAfA;EAuBE,2BAAA;EACA,WAAA;EACA,uCAAA;AALF;AAOE;;EAEE,2BAAA;AALJ;AAQE;EACE,eAAA;AANJ;AASE;EACE,gBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AATJ;AAYE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAVJ;AAaE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAXJ","sourcesContent":["@import 'src/vars';\n\n.card-component-container {\n  padding: 30px;\n\n  @media only screen and (max-width: $mobile_break) {\n    padding: 10px;\n  }\n}\n\n.topic-overview-card {\n  &.highlight {\n    color: var(--base_color2);\n    background-color: var(--color_primary_500);\n\n    h3,\n    h5 {\n      color: var(--base_color2);\n    }\n\n    p {\n      color: #d2dcff;\n    }\n\n    &:hover {\n      background-color: var(--color_primary_500);\n    }\n  }\n\n  &:hover {\n    background-color: var(--gray_insights3_hover);\n  }\n\n  color: var(--primary_dark2);\n  width: 100%;\n  background-color: var(--gray_insights3);\n\n  h3,\n  h5 {\n    color: var(--primary_dark2);\n  }\n\n  h5 {\n    font-size: 16px;\n  }\n\n  .semibold {\n    font-weight: 600;\n  }\n\n  .bold {\n    font-weight: 700;\n  }\n\n  p {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 15px;\n  }\n\n  &.analytics {\n    border-radius: 16px;\n    width: 100%;\n    max-width: 429px;\n    height: 306px;\n  }\n\n  &.related-topic {\n    border-radius: 8px;\n    width: 100%;\n    max-width: 317px;\n    height: 216px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
